import { z } from 'zod';
import { definePath } from './definePath';
import { relativePathSchema } from './relativePath';

// App-global routes that don't belong to any feature domain: the root index
// redirect, the generic error page, and the forbidden page. Lives alongside the
// router because they are structural (consumed by router internals and by
// `app/queryClient.tsx` for the 403 redirect target), not feature surface.
export const RouterPaths = {
  index: definePath('public', { de: '/', en: '/' }),
  error: definePath(
    'public',
    { de: '/fehler', en: '/error' },
    {
      search: z.object({
        eventId: z.string().optional(),
        // Rendered as a link's href on the error page, so it takes the shared redirect guard.
        retryUrl: relativePathSchema.optional(),
      }),
    },
  ),
  forbidden: definePath('authenticated', { de: '/verboten', en: '/forbidden' }),
} as const;
